import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyMetadata, getDefaultRouteMetadata } from './metadata';

export default function RouteSeo() {
  const location = useLocation();

  useEffect(() => {
    const metadata = getDefaultRouteMetadata(location.pathname);
    applyMetadata({
      ...metadata,
      pathname: location.pathname,
    });
  }, [location.pathname]);

  return null;
}
